// A conversation the parent page pins, such as the one a Scenario Center
// scenario keeps per user. It doubles as the Firestore document id.
const SCOPED_CHAT_ID_PATTERN = /^[A-Za-z0-9_-]{1,200}$/;

export const readScopedChatId = (value) =>
  typeof value === "string" && SCOPED_CHAT_ID_PATTERN.test(value)
    ? value
    : null;
